import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

export interface IFlashback {
  id: number;
  content: string;

  //  前端字段
  unread?: boolean;
  chatSessionId?: string;
}

export interface IReqFlashback {
  longitude: number;
  latitude: number;
}

export const getFlashback = (data?: IReqFlashback) => {
  return Request<CommonResponse<IFlashback> | EmptyResponse>({
    url: '/rest/os/flashback/get',
    method: 'post',
    data: data || {}
  });
};
